<template>
  <div :style="{ width, height }" ref="echarts"></div>
</template>

<script>
const echarts = window.echarts;

function initChart(element, option) {
  let chart = echarts.init(element, "macarons");
  chart.setOption(option, true);
  return chart;
}
export default {
  props: ["option", "width", "height"],
  name: "Echarts",
  data() {
    return {
      chart: null
    };
  },

  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (this.option) {
        this.chart = initChart(this.$refs.echarts, this.option);
      }
    }
  },
  watch: {
    option: {
      handler(option, _option) {
        if (this.chart) {
          // 有数据时重新渲染图表
          this.chart.clear();
          this.chart.resize();
          this.chart.setOption(option, true);
        } else {
          this.init();
        }
      },
      deep: true
    }
  }
};
</script>
